import {
  USER_SET_USER,
  USER_SET_ACCESS_TOKEN,
  USER_SET_REFRESH_TOKEN,
  USER_SET_SELECTED_COMMUNITY,
  USER_SET_IS_LOGGED_IN,
  USER_SET_PERMISSIONS,
} from "../types";

const initialState = {
  user: {},
  token: {
    accessToken: null,
    refreshToken: null,
  },
  permissions: [],
  selectedCommunity: {},
  isLoggedIn: null,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_SET_ACCESS_TOKEN:
      return {...state, token: {...state.token, accessToken: action.data}};
    case USER_SET_REFRESH_TOKEN:
      return {...state, token: {...state.token, refreshToken: action.data}};
    case USER_SET_SELECTED_COMMUNITY:
      return {...state, selectedCommunity: action.data};
    case USER_SET_USER:
      return { ...state, user: action.data };
    case USER_SET_IS_LOGGED_IN:
      return { ...state, isLoggedIn: action.data };
    case USER_SET_PERMISSIONS:
      return { ...state, permissions: action.data };
    default:
      return state;
  }
};

export default UserReducer;
